<template>
	<div
		class="g-block-title-brand g-block-title-padding"
		:class="{
			'g-block-title-brand--edit': editable,
			'is-active': editable && active,
			'g-block-title-brand--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-brand__row">
			<div class="g-block-title-brand__dots" aria-hidden="true">
				<span
					class="g-block-title-brand__dot g-block-title-brand__dot--primary"
					:style="{ background: themeColor }"
				></span>
				<span
					class="g-block-title-brand__dot g-block-title-brand__dot--secondary"
					:style="{ background: lightColor }"
				></span>
			</div>

			<div class="g-block-title-brand__part g-block-title-brand__part--primary">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-brand__text g-block-title-brand__text--primary"
					fit-content
					:model-value="data.primaryText"
					placeholder="中文标题"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-brand__text g-block-title-brand__text--primary"
					v-html="data.primaryText || ''"
				></div>
			</div>

			<div class="g-block-title-brand__part g-block-title-brand__part--secondary" :style="{ color: lightColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-brand__text g-block-title-brand__text--secondary"
					fit-content
					:model-value="data.secondaryText"
					placeholder="标题"
					@update:model-value="onSecondaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-brand__text g-block-title-brand__text--secondary"
					v-html="data.secondaryText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { lightenHexColor } from '../../../utils/richText.js';

	export default {
		name: 'GBlockTitleBrand',
		components: { RichTextEditable },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select', 'update'],
		computed: {
			themeColor() {
				return getTitleThemeColor(this.data);
			},
			lightColor() {
				return lightenHexColor(this.themeColor);
			},
		},
		methods: {
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onPrimaryUpdate(primaryText) {
				this.$emit('update', { primaryText });
			},
			onSecondaryUpdate(secondaryText) {
				this.$emit('update', { secondaryText });
			},
		},
	};
</script>

<style scoped lang="less">
	@dot-size: 14px;
	@dot-overlap: 6px;

	.g-block-title-brand {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-brand__row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}

	.g-block-title-brand__dots {
		position: relative;
		width: (@dot-size * 2 - @dot-overlap);
		height: @dot-size;
		flex-shrink: 0;
	}

	.g-block-title-brand__dot {
		position: absolute;
		top: 0;
		width: @dot-size;
		height: @dot-size;
		border-radius: 50%;
	}

	.g-block-title-brand__dot--primary {
		left: 0;
		z-index: 2;
	}

	.g-block-title-brand__dot--secondary {
		left: (@dot-size - @dot-overlap);
		z-index: 1;
	}

	.g-block-title-brand__part {
		display: inline-flex;
		align-items: baseline;
		min-width: 0;
	}

	.g-block-title-brand__text {
		display: inline-flex;
		align-items: baseline;
		line-height: 1.2;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;

		&--primary {
			font-size: 18px;
			font-weight: 700;
			color: #333;
		}

		&--secondary {
			font-size: 18px;
			font-weight: 700;
			color: inherit;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: baseline;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.2;
			min-height: unset;
			height: auto;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: baseline;
			color: inherit;
		}
	}

	.g-block-title-brand--h5 {
		@h5-dot-size: 0.28rem;
		@h5-dot-overlap: 0.12rem;

		.g-block-title-brand__row {
			gap: 0.2rem;
		}

		.g-block-title-brand__dots {
			width: (@h5-dot-size * 2 - @h5-dot-overlap);
			height: @h5-dot-size;
		}

		.g-block-title-brand__dot {
			width: @h5-dot-size;
			height: @h5-dot-size;
		}

		.g-block-title-brand__dot--secondary {
			left: (@h5-dot-size - @h5-dot-overlap);
		}

		.g-block-title-brand__text--primary {
			font-size: 0.36rem;
		}

		.g-block-title-brand__text--secondary {
			font-size: 0.36rem;
		}
	}
</style>
